module.exports = __webpack_public_path__ + "static/media/Human_Walk_030_360.80cfd246.jpg";